import { Button, Empty, Menu, Select, Skeleton, Space, Switch, Table, Tour, Typography } from "antd";

import { LoadingOutlined } from "@ant-design/icons";
import Link from "antd/es/typography/Link";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import onBoardingPhoneSwitch from "../../assets/gif/onBoardingPhoneSwitch.gif";
import HButton from "../../components/custom/input/button/Button";
import HSelect from "../../components/custom/input/select/Select";
import { TEAMS_USER_IMPRESSION_SERVICE_ID } from "../../constants/AppConstants";
import { AppContext } from "../../context/AppContext";
import Input from "../../components/custom/input/input/Input";
import useHttp from "../../hooks/useHttp";
import { successNotification } from "../utils/CommonNotifications";
import { formatPhoneNumber, MAX_INPUT_LENGTH_FOR_FRIENDLY_NAME } from "../utils/commonUtils";
import { ConfirmAlertModal, MessageAreaInfo } from "../utils/CommonVessels";
import "./../../assets/css/services/configPhone.css";
import HNotification from "../../components/custom/notification/HNotification";

function ConfigPhone({ rightServiceObj, setRightServiceObj, setShowFinishButton, campaignStatus }) {
  const { state } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ref = useRef(null);
  const [configurePhoneGifOpen, setConfigurePhoneGifOpen] = useState(false);
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [selectedMenuItem, setSelectedMenuItem] = useState();
  const [phoneNumberList, setPhoneNumberList] = useState();
  const [phoneUniqueIdMap, setPhoneUniqueIdMap] = useState({});
  const [pagesList, setPagesList] = useState([]);
  const [msgSidList, setMsgSidList] = useState([]);
  const [isSwitchLoading, setIsSwitchLoading] = useState([]);
  const [phoneData, setPhoneData] = useState([]);
  const [msgData, setMsgData] = useState([]);
  const [alphaDataOptions, setAlphaDataOptions] = useState([]);
  const [alphaData, setAlphaData] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [numbersApiLoading, setNumbersApiLoading] = useState(true);
  const [addBtnLoading, setAddBtnLoading] = useState(false);
  const [departmentsList, setDepartmentsList] = useState([]);
  const [alphaDataLoading, setAlphaDataLoading] = useState(false);
  const [deletePhoneModal, setDeletePhoneModal] = useState({
    open: false,
    phoneNumber: null,
  });
  const [selectedPhone, setSelectedPhone] = useState({
    friendlyName: "",
    phoneNumber: "",
  });

  const [showEditContent, setShowEditContent] = useState(false);
  const tourRef = useRef(null);
  const items = appProperties.providerCommonObj?.menu;
  const integId = rightServiceObj?.integId;
  const authorized = rightServiceObj?.authorized;
  const handleMenuClick = (event) => {
    setSelectedMenuItem(event.key);
    setShowEditContent(false);
    setSelectedPhone({});
  };
  const { fetchData } = useHttp();

  useEffect(() => {
    let currentPhones = phoneData?.filter((obj) => obj?.integId === integId);
    if (currentPhones?.length > 0) {
      setConfigurePhoneGifOpen(false);
    } else {
      if (phoneNumberList?.length > 0 && currentPhones?.length < 1 && tourRef?.current !== "done") {
        setConfigurePhoneGifOpen(true);
        tourRef.current = "done";
      }
    }
  }, [phoneData, phoneNumberList, integId]);

  useEffect(() => {
    if (integId && authorized) {
      const fetchApi = async () => {
        setNumbersApiLoading(true);
        await fetchData(
          appProperties?.providerCommonObj?.category === "messenger" ? `omessage/${integId}/facebook/savedPages` : `helloSend/savedNumbers`,
          "GET",
          null,
          appProperties
        ).then((response) => {
          try {
            if (response) {
              const responseData = JSON.parse?.(response);
              if (responseData?.data?.data.length > 0) {
                let currentPhones = responseData?.data?.data.filter((obj) => obj?.integId === integId);
                if (currentPhones?.length > 0 || responseData?.data?.messagingServices?.length > 0) {
                  if (rightServiceObj?.displayName === "Teams") {
                    if (currentPhones?.length > 0 && currentPhones?.some((obj) => obj?.phoneUniqueId?.startsWith("teams_"))) {
                      setShowFinishButton(true);
                    }
                  } else {
                    setShowFinishButton(true);
                  }
                }
                responseData.data.data.map((data) => {
                  if (data?.phoneUniqueId) {
                    setPhoneData((prevState) => [...prevState, data]);
                  } else {
                    setAlphaData((prevState) => [...prevState, data]);
                    if (appProperties?.providerCommonObj?.category === "messenger") {
                      setPageData((prevState) => [...prevState, data]);
                    }
                  }
                  return null;
                });
              } else {
                setPhoneData([]);
              }
              setMsgData(responseData?.data?.messagingServices ?? []);
            }
          } catch (error) {
            console.error("Error processing response:", error);
          }
        });
      };
      fetchApi().catch((err) => {});
      appProperties?.providerCommonObj?.category === "messenger" ? setSelectedMenuItem("Select Pages") : setSelectedMenuItem("Phone number");
    } else {
      setPhoneNumberList([]);
      setMsgSidList([]);
      setPagesList([]);
      setSelectedMenuItem("");
    }
  }, [authorized, integId, state, appProperties.integId, fetchData, setShowFinishButton]);

  useEffect(() => {
    if (selectedMenuItem === "AlphaSender" && alphaDataOptions?.length <= 0 && alphaDataLoading === false) {
      setAlphaDataLoading(true);
      fetchNumbersApi().finally(() => {
        setAlphaDataLoading(false);
      });
    }
  }, [selectedMenuItem]);

  useEffect(() => {
    if (integId && appProperties?.savedNumbers && appProperties?.providerCommonObj?.handleSavedNumberProcessingForOnboardingPageRedirect) {
        appProperties?.providerCommonObj?.handleSavedNumberProcessingForOnboardingPageRedirect(
          appProperties,
          integId,
          location,
          navigate,
          searchParams,
          appProperties?.savedNumbers
        );
    }
  }, [appProperties?.savedNumbers, integId]);

  const fetchNumbersApi = async () => {
    if (selectedMenuItem !== "AlphaSender") {
      setNumbersApiLoading(true);
    }
    var targetUrl =
      appProperties?.providerCommonObj?.category === "messenger" ? `omessage/${integId}/facebook/pages` : `omessage/${integId}/numbers`;
    if (rightServiceObj?.displayName === "Teams") {
      targetUrl = `teams/numbers?leftServiceId=${TEAMS_USER_IMPRESSION_SERVICE_ID}`;
    }
    if (selectedMenuItem === "AlphaSender") {
      targetUrl = `omessage/${integId}/numbers?capabilities=alphaSenders`;
    }
    await fetchData(targetUrl, "GET", null, appProperties)
      .then((response) => {
        try {
          if (response) {
            const responseData = JSON.parse(response);
            if (responseData?.data?.status) {
              if (responseData?.data?.data) {
                let getNumberList = responseData.data.data;
                if (typeof getNumberList === "string") {
                  getNumberList = JSON.parse(getNumberList);
                }
                if (appProperties?.providerCommonObj?.category !== "messenger") {
                  setPhoneNumberList([...new Set([...(getNumberList?.phone || [])])]);
                  setPhoneUniqueIdMap(getNumberList?.phoneUniqueIdMap || {});
                } else {
                  setPagesList(getNumberList);
                }
                setNumbersApiLoading(false);
                if (rightServiceObj?.displayName === "Teams") {
                  setRightServiceObj((prev) => ({
                    ...prev,
                    customAuth: true,
                  }));
                }
              } else if (selectedMenuItem !== "AlphaSender") {
                setPhoneNumberList([]);
                setNumbersApiLoading(false);
              }
              if (responseData?.data?.messagingServices) {
                let getMsgServicesLists = responseData.data.messagingServices;
                const msgSidsList = getMsgServicesLists.map((service) => ({
                  friendlyName: service.friendlyName,
                  sid: service.sid,
                }));
                setMsgSidList(msgSidsList);
              }
              if (responseData?.data?.alphaSenders) {
                let alphaSendersList = responseData?.data?.alphaSenders;
                if (alphaSendersList) {
                  // removing already saved alpha senders
                  alphaSendersList = alphaSendersList?.filter(
                    (alphaSenderData) =>
                      !alphaData?.some(
                        (savedAlphaSender) =>
                          savedAlphaSender?.phoneNumber === alphaSenderData?.alphaSender &&
                          savedAlphaSender?.messageServiceId === alphaSenderData?.serviceSid
                      )
                  );
                  alphaSendersList = alphaSendersList.map((alphaSender) => ({
                    value: alphaSender?.sid,
                    label: alphaSender?.alphaSender,
                    data: alphaSender,
                  }));
                  setAlphaDataOptions(alphaSendersList);
                }
              }
              if (responseData?.data?.departments) {
                let getDepartmentsLists = responseData.data.departments;
                setDepartmentsList(getDepartmentsLists);
              }
            } else if (rightServiceObj?.displayName === "Teams") {
              setRightServiceObj((prev) => ({
                ...prev,
                customAuth: false,
              }));
            }
          }
        } catch (error) {
          console.error("Error processing response:", error);
        }
      })
      .catch((err) => {
        setNumbersApiLoading(false);
      })
      .finally(() => {
        setNumbersApiLoading(false);
      });
  };

  useEffect(() => {
    if (integId && authorized) {
      fetchNumbersApi().catch((err) => {});
      appProperties?.providerCommonObj?.category === "messenger" ? setSelectedMenuItem("Select Pages") : setSelectedMenuItem("Phone number");
    } else {
      setPhoneNumberList([]);
      setMsgSidList([]);
      setPagesList([]);
      setSelectedMenuItem("");
    }
  }, [integId, authorized, rightServiceObj?.callPhoneNumbersFromService]);

  const handlePhoneNumberApi = (phoneNumber, switchType) => {
    if (switchType === true) {
      if (phoneNumber === "Table") {
        if (!selectedPhone?.phoneNumber) {
          HNotification.notify({
            type: "error",
            message: "Error",
            description: selectedMenuItem === "AlphaSender" ? "Select a valid Alpha Sender" : "Select a valid Messaging Service ",
          });
          return;
        }
      }
      setAddBtnLoading(true);
      handleAddPhone(phoneNumber);
    } else if (switchType === false) {
      setIsSwitchLoading({ ...isSwitchLoading, [phoneNumber]: true });
      setDeletePhoneModal({ open: true, phoneNumber: phoneNumber });
    }
  };

  const handleAddPhone = (phoneNumber) => {
    let appData = {};
    switch (selectedMenuItem) {
      case "Phone number":
        setIsSwitchLoading({ ...isSwitchLoading, [phoneNumber]: true });
        appData = {
          phoneNumber: phoneNumber,
          friendlyName: selectedPhone?.friendlyName || "",
          isMessagingService: false,
          alphaSender: false,
          messageServiceId:
            (msgSidList?.length > 0 &&
              msgSidList?.find((obj) => {
                return obj?.friendlyName?.startsWith("HelloSend");
              })?.sid) ||
            "",
          phoneUniqueId: phoneUniqueIdMap[phoneNumber] || "",
        };
        if (rightServiceObj?.displayName === "Teams") {
          appData = { ...appData, phoneUniqueId: `teams_${phoneNumber}` };
        }
        break;

      case "Select Pages":
        setIsSwitchLoading({ ...isSwitchLoading, [phoneNumber.id]: true });
        appData = {
          pageId: phoneNumber.id,
          osyncId: appProperties.osyncId,
          friendlyName: phoneNumber.name,
        };
        break;

      default:
        appData = {
          phoneNumber: selectedPhone?.phoneNumber,
          friendlyName: selectedPhone?.friendlyName,
          isMessagingService: selectedMenuItem === "MessagingService",
          messageServiceId: selectedPhone?.messageServiceId,
          alphaSender: selectedMenuItem === "AlphaSender",
        };
        break;
    }
    fetchData(
      appProperties?.providerCommonObj?.category === "messenger" ? `omessage/${integId}/facebook/savePage` : `omessage/${integId}/savePhone`,
      "POST",
      appData,
      appProperties
    ).then((response) => {
      try {
        if (response) {
          setConfigurePhoneGifOpen(false);
          let savePhoneResp = JSON.parse(response);

          let resp = savePhoneResp?.data?.data;
          if (savePhoneResp?.data?.license) {
            HNotification.notify({
              type: "error",
              message: savePhoneResp?.data?.license?.code,
              description: savePhoneResp?.data?.license?.description,
            });
            setIsSwitchLoading({ ...isSwitchLoading, [phoneNumber]: false });
            setAddBtnLoading(false);
          }
          if (savePhoneResp?.data?.errorMessage) {
            setIsSwitchLoading({ ...isSwitchLoading, [phoneNumber]: false });
            HNotification.notify({ type: "error", message: "Error", description: savePhoneResp.data.errorMessage });
          } else if (savePhoneResp?.data?.status) {
            const isNewTeamsNumber = savePhoneResp?.data?.data?.phoneUniqueId?.startsWith("teams_");
            const successNotificationText = `${selectedMenuItem} added. ${
              rightServiceObj?.displayName === "Teams" && isNewTeamsNumber
                ? "Please continue with the Business Verification"
                : "You can now send Message to clients"
            }`;
            successNotification(successNotificationText);
            switch (selectedMenuItem) {
              case "Phone number":
                setPhoneData(phoneData?.length > 0 ? [...phoneData, resp] : [resp]);
                let currentPhones = phoneData?.filter((obj) => obj?.integId === integId);
                if (currentPhones?.length === 0 || rightServiceObj?.displayName === "Teams") {
                  setShowFinishButton(true);
                }
                setIsSwitchLoading({
                  ...isSwitchLoading,
                  [phoneNumber]: false,
                });
                break;

              case "MessagingService":
                let newMsgData = {};
                if (msgData.some((obj) => obj.phoneNumber === selectedPhone.phoneNumber && resp)) {
                  newMsgData = msgData.filter((obj) => obj.phoneNumber !== selectedPhone.phoneNumber);
                }
                setMsgData(
                  msgData.some((obj) => obj.phoneNumber === selectedPhone.phoneNumber && resp)
                    ? [...newMsgData, resp]
                    : msgData?.length > 0
                    ? [...msgData, resp]
                    : [resp]
                );
                setShowFinishButton(true);
                setAddBtnLoading(false);
                setShowEditContent(false);
                setIsSwitchLoading({
                  ...isSwitchLoading,
                  [phoneNumber]: false,
                });
                break;

              case "AlphaSender":
                setAlphaData(alphaData?.length > 0 ? [...alphaData, resp] : [resp]);
                const filteredAlphaDataOptions = alphaDataOptions.filter(
                  (obj) => obj.data?.serviceSid !== resp?.messageServiceId && resp?.phoneNumber !== obj.data?.alphaSender
                );
                setAlphaDataOptions(filteredAlphaDataOptions);
                setIsSwitchLoading({
                  ...isSwitchLoading,
                  [phoneNumber]: false,
                });
                setSelectedPhone({});
                setAlphaDataLoading(false);
                setShowEditContent(false);
                setAddBtnLoading(false);
                break;

              case "Select Pages":
                setPageData(pageData?.length > 0 ? [...alphaData, resp] : [resp]);
                setShowFinishButton(true);
                setIsSwitchLoading({
                  ...isSwitchLoading,
                  [phoneNumber.id]: false,
                });
                break;

              default:
                setIsSwitchLoading({
                  ...isSwitchLoading,
                  [phoneNumber]: false,
                });
                setIsSwitchLoading({
                  ...isSwitchLoading,
                  [phoneNumber?.id]: false,
                });
                setShowEditContent(false);
                setAddBtnLoading(false);
                break;
            }
            let phoneNumberToCheck = phoneNumber === "Table" ? selectedPhone?.phoneNumber : phoneNumber;

            setAppProperties((prevApp) => ({
              ...prevApp,
              savedNumbers: [...(prevApp?.savedNumbers?.filter((obj) => obj?.phoneNumber !== phoneNumberToCheck) || []), resp],
              allNumbers: [...(prevApp?.allNumbers?.filter((obj) => obj?.phoneNumber !== phoneNumberToCheck) || []), resp],
              licenseObj: {
                ...prevApp?.licenseObj,
                licenseDetails: { ...prevApp?.licenseObj?.licenseDetails, ...(savePhoneResp?.data?.omniLicense ?? {}) },
              },
            }));
          } else {
            setIsSwitchLoading({
              ...isSwitchLoading,
              [phoneNumber]: false,
            });
            setAddBtnLoading(false);
          }
        }
      } catch (error) {
        console.error("Error processing response:", error);
      } finally {
        setAddBtnLoading(false);
      }
    });
  };

  const handleDeletePhone = async (phoneNumber) => {
    await fetchData(
      appProperties?.providerCommonObj?.category === "messenger"
        ? `omessage/${integId}/facebook/page/${phoneNumber.id}`
        : `omessage/${integId}/deletePhone?phoneNumber=${encodeURIComponent(phoneNumber)}`,
      "DELETE",
      null,
      appProperties
    )
      .then(function (resp) {
        try {
          if (resp) {
            resp = JSON.parse(resp);
            setIsSwitchLoading({ ...isSwitchLoading, [phoneNumber]: false });
            setDeletePhoneModal((prev) => ({ ...prev, open: false }));
            if (resp?.status === 200) {
              if (appProperties?.providerCommonObj?.category === "messenger") {
                setPageData((prevPageData) => prevPageData.filter((num) => num.pageId !== phoneNumber.id));
              } else {
                setPhoneData((prevPhoneData) => prevPhoneData.filter((num) => num.phoneNumber !== phoneNumber));
              }
              setSelectedPhone({});

              let currentPhones = phoneData.filter((obj) => obj?.integId === integId && obj?.phoneNumber !== (phoneNumber || phoneNumber?.id));
              if (currentPhones?.length > 0 || msgData?.length > 0) {
                setShowFinishButton(true);
              } else {
                setShowFinishButton(false);
              }
              setAppProperties((prevApp) => ({
                ...prevApp,
                savedNumbers: prevApp?.savedNumbers?.filter((obj) => obj?.phoneNumber !== phoneNumber),
                allNumbers: prevApp?.allNumbers?.filter((obj) => obj?.phoneNumber !== phoneNumber),
              }));
            }
          }
        } catch (error) {
          console.error("Error processing response:", error);
        }
      })
      .catch((err) => {
        setIsSwitchLoading({ ...isSwitchLoading, [phoneNumber]: false });
      });
  };

  const handleEditPhone = (phoneNumber) => {
    let queryObj = {};
    if (selectedMenuItem === "Phone number") {
      queryObj = phoneData.find((element) => element.phoneNumber === phoneNumber);
    } else if (selectedMenuItem === "MessagingService") {
      queryObj = msgData.find((element) => element.phoneNumber === phoneNumber);
    } else {
      queryObj = phoneData.find((element) => element.phoneNumber === phoneNumber);
    }

    setSelectedPhone(queryObj);
  };

  const PhoneTable = () => {
    return (
      <>
        <Table
          scroll={{ y: 350 }}
          pagination={false}
          className="phoneAddTable"
          dataSource={selectedMenuItem === "MessagingService" ? msgData : alphaData}
          columns={[
            {
              title: "Friendly Name",
              dataIndex: "friendlyName",
              key: "friendlyName",
            },

            selectedMenuItem === "MessagingService"
              ? {
                  title: "Messaging Service ID",
                  dataIndex: "messageServiceId",
                  key: "messageServiceId",
                }
              : {
                  title: "Alpha Sender ID",
                  dataIndex: "phoneNumber",
                  key: "phoneNumber",
                },
          ]}
        />
        {selectedMenuItem === "AlphaSender" && !showEditContent && <AlphaSenderInfo showFullWidth={false} />}
      </>
    );
  };
  function getFriendlyName(phoneNumber) {
    const queryObj = phoneData.find((element) => element.phoneNumber === phoneNumber);
    let friendlyName = queryObj?.friendlyName;
    return <>{friendlyName ? <span>{"(" + friendlyName + ")"}</span> : null}</>;
  }

  const doOnCancel = () => {
    setDeletePhoneModal((prev) => ({ ...prev, open: false }));
    setIsSwitchLoading({
      ...isSwitchLoading,
      [deletePhoneModal?.phoneNumber]: false,
    });
  };

  const doOnConfirm = async () => {
    await handleDeletePhone(deletePhoneModal?.phoneNumber);
  };
  const steps = [
    {
      description: (
        <>
          <img alt="onBoardingPhoneSwitch.gif" style={{ height: "70px" }} src={onBoardingPhoneSwitch} />
        </>
      ),
      placement: "right",
      target: () => ref.current,
    },
  ];
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setConfigurePhoneGifOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="d-grid gap-4 hs-border-6 hs-border-grey bg-white hs-lg-h-700-px">
        <div className={`${!items?.length > 0 ? "mt-1" : "mt-3"} `}>
          {showEditContent ? (
            <UpdatePhone
              selectedMenuItem={selectedMenuItem}
              selectedPhone={selectedPhone}
              handlePhoneNumberApi={handlePhoneNumberApi}
              integId={integId}
              appProperties={appProperties}
              setShowEditContent={setShowEditContent}
              msgSidList={msgSidList}
              setSelectedPhone={setSelectedPhone}
              setPhoneData={setPhoneData}
              alphaSender={selectedMenuItem === "AlphaSender"}
              messagingService={selectedMenuItem === "MessagingService"}
              setAddBtnLoading={setAddBtnLoading}
              addBtnLoading={addBtnLoading}
              setAppProperties={setAppProperties}
              departmentsList={departmentsList}
              alphaDataLoading={alphaDataLoading}
              alphaDataOptions={alphaDataOptions}
            />
          ) : items?.length > 0 ? (
            <div className="d-flex justify-content-between align-items-center">
              <Menu
                className={`pt-0 pb-1 my-0 ${rightServiceObj?.rightServiceName === "twilio" ? "addPhoneMenu ps-3" : "configPhoneMenu"}`}
                onClick={handleMenuClick}
                selectedKeys={[selectedMenuItem]}
                mode="horizontal"
                disabled={authorized === true ? false : true}
                items={items}
              />
              {selectedMenuItem !== "Phone number" && (
                <div className="d-flex justify-content-between align-items-center m-4 mt-1 mb-1 ps-5">
                  <HButton
                    buttonClassName="hs-fs-16 px-3"
                    size="s"
                    type="outline"
                    onClick={() => {
                      setShowEditContent(true);
                    }}
                  >
                    Configure
                  </HButton>
                </div>
              )}
            </div>
          ) : null}
          {showEditContent
            ? ""
            : selectedMenuItem && (
                <div style={{ overflow: "auto", height: "33.5rem" }} className="flex-grow-* scrollWidthColor ">
                  {selectedMenuItem === "Phone number" ? (
                    <div className="ps-3">
                      <div className="d-flex flex-column justify-content-start align-items-">
                        <div className="d-flex align-items-center justify-content-between">
                          <Tour closeIcon={false} open={configurePhoneGifOpen} onClose={() => setConfigurePhoneGifOpen(false)} steps={steps} />
                        </div>
                        <div className="d-flex flex-column gap-4">
                          {numbersApiLoading === true ? (
                            <div className="d-flex justify-content-center antd-loading-icon hs-fs-24">
                              <LoadingOutlined spin className="my-5" />
                            </div>
                          ) : phoneNumberList?.length > 0 ? (
                            <Table
                              dataSource={phoneNumberList}
                              pagination={false}
                              className="m-0 voiceNumberTable h-100 phoneAddTable overflow-hidden"
                              showHeader={true}
                              rowKey={(record, index) => index}
                              scroll={{ y: 460 }}
                              columns={[
                                {
                                  title: "Numbers",
                                  key: "phoneNumber",
                                  width: "60%",
                                  render: (value, record, index) => {
                                    const obj = record;
                                    return (
                                      <div
                                        ref={index === 0 ? ref : null}
                                        className="hs-overflow-wrap-break-word d-flex align-items-center hs-fw-500"
                                      >
                                        {obj?.includes(":::") ? obj?.split(":::")[1] : obj}
                                        {getFriendlyName(obj)}
                                        {phoneData.some((element) => {
                                          return (
                                            formatPhoneNumber(element.phoneNumber) === formatPhoneNumber(obj) && element.integId === integId
                                          );
                                        }) ? (
                                          <div
                                            className="number-edit-icon actionIconsSprite ms-1"
                                            onClick={() => {
                                              handleEditPhone(obj);
                                              setShowEditContent(true);
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></div>
                                        ) : null}
                                      </div>
                                    );
                                  },
                                },
                                {
                                  title: "Status",
                                  key: "status",
                                  width: "20%",
                                  align: "center",
                                  render: (value, record, index) => {
                                    const obj = record;
                                    return (
                                      <Switch
                                        loading={isSwitchLoading[obj]}
                                        className="addPhoneSwitch"
                                        data-cy={`phone-number-switch-${obj}`}
                                        size="small"
                                        value={obj}
                                        checked={phoneData.some((element) => {
                                          return (
                                            formatPhoneNumber(element.phoneNumber) === formatPhoneNumber(obj) && element.integId === integId
                                          );
                                        })}
                                        disabled={rightServiceObj?.rightServiceName === "unipile_whatsapp"}
                                        onClick={(e) => {
                                          handleEditPhone(obj);
                                          handlePhoneNumberApi(obj, e);
                                        }}
                                      />
                                    );
                                  },
                                },
                              ]}
                            />
                          ) : (
                            !phoneNumberList?.length &&
                            numbersApiLoading === false && (
                              <Empty
                                style={{ marginTop: "30%" }}
                                description={`No ${appProperties?.providerCommonObj?.category === "messenger" ? "pages" : "numbers"} in your ${
                                  rightServiceObj?.displayName
                                } Account.`}
                              />
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  ) : selectedMenuItem === "MessagingService" || selectedMenuItem === "AlphaSender" ? (
                    <PhoneTable />
                  ) : selectedMenuItem === "Select Pages" ? (
                    <div>
                      <div className="d-flex flex-column justify-content-start align-items- mt-3 ms-3 me-5">
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="ms-3 m-2" style={{ color: "#030229" }}>
                            List of Pages
                          </span>
                        </div>
                        {pagesList?.length > 0 ? (
                          pagesList.map((obj, index) => {
                            return (
                              <div key={index} className="d-flex justify-content-between align-items-center m-3">
                                <div className="d-flex align-items-center">
                                  <div className="phoneLogoSprites listPhone me-3"></div>
                                  <Typography.Text ellipsis style={{ fontWeight: 600 }}>
                                    {obj.name}
                                  </Typography.Text>
                                </div>
                                <Switch
                                  key={"switch" + index}
                                  loading={isSwitchLoading[obj.id]}
                                  className="addPhoneSwitch"
                                  size="small"
                                  value={obj.id}
                                  checked={pageData.some((element) => {
                                    return element.pageId === obj.id;
                                  })}
                                  onClick={(e) => {
                                    handlePhoneNumberApi(obj, e);
                                  }}
                                />
                              </div>
                            );
                          })
                        ) : numbersApiLoading === true ? (
                          <Skeleton className="m-2" paragraph={{ rows: 4 }} active />
                        ) : (
                          phoneNumberList?.length < 1 &&
                          numbersApiLoading === false && (
                            <Empty
                              style={{ marginTop: "30%" }}
                              description={`No ${appProperties?.providerCommonObj?.category === "messenger" ? "pages" : "numbers"} in your ${
                                rightServiceObj?.displayName
                              } Account.`}
                            />
                          )
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
        </div>
      </div>
      <ConfirmAlertModal
        onCancel={doOnCancel}
        open={deletePhoneModal.open}
        onConfirm={doOnConfirm}
        centered={true}
        dataCyForConfirmBtn="phone-configuration-revoke-confirmation-btn"
        dataCyForCancelBtn="phone-configuration-revoke-cancel-btn"
        alertIcon={<div className="phoneLogoSprites delete-icon me-4" />}
        titleContent={"Are you sure you want to disconnect?"}
        modalContent={`If you proceed, you won't be able to send or receive messages, and
              you might miss messages from customers. Confirm if you still want
              to proceed.`}
        loading={isSwitchLoading?.phoneNumber}
        buttonConfirm={"Yes, confirm"}
      />
    </>
  );
}
export default ConfigPhone;

const UpdatePhone = ({
  handlePhoneNumberApi,
  alphaSender,
  messagingService,
  setSelectedPhone,
  selectedMenuItem,
  selectedPhone,
  integId,
  appProperties,
  setAppProperties,
  setShowEditContent,
  msgSidList,
  addBtnLoading,
  setAddBtnLoading,
  setPhoneData,
  departmentsList,
  alphaDataOptions,
  alphaDataLoading,
}) => {
  const { fetchData } = useHttp();
  const [associatedSid, setAssociatedSid] = useState("");
  const [addBtnDisabled, setAddBtnDisabled] = useState(false);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const [agentsList, setAgentsList] = useState([]);

  useEffect(() => {
    if (appProperties?.licenseObj?.allLicensedUserDetails) {
      const updatedUsers = appProperties?.licenseObj?.allLicensedUserDetails?.map((user) => {
        return {
          ...user,
          label: [user?.firstName, user?.lastName].filter(Boolean).join(" ") + " (" + user?.email + ")",
          value: user?.remoteUserId,
        };
      });
      setAgentsList(updatedUsers);
    }
  }, [appProperties?.licenseObj?.allLicensedUserDetails]);

  const handlePhoneNumberDepartmentAssociation = (departmentId) => {
    setSelectedDepartmentId(departmentId);
  };
  const handlePhoneNumberTicketAssignee = (agentId) => {
    setSelectedAgentId(agentId);
  };

  const handlePhoneUpdate = () => {
    setAddBtnLoading(true);
    let body = {
      alphaSender: alphaSender,
      isMessagingService: messagingService,
      phoneNumber: selectedPhone?.phoneNumber,
      friendlyName: selectedPhone?.friendlyName,
      messageServiceId: selectedPhone?.messageServiceId,
      departmentId: selectedDepartmentId,
      ticketAssigneeId: selectedAgentId,
    };
    fetchData(`omessage/${integId}/updatePhone?associatedSid=${associatedSid}`, "PUT", body, appProperties)
      .then(function (response) {
        try {
          if (response) {
            response = JSON.parse(response);
            if (response?.data?.errorMessage) {
              HNotification.notify({ type: "error", message: "Error", description: response.data.errorMessage });
            } else if (response?.data?.status) {
              if (setPhoneData) {
                successNotification("Phone number updated. Continue engaging with clients.");
                setPhoneData((prev) => {
                  let prevObjs = prev.filter((obj) => obj.phoneNumber !== response?.data?.data?.phoneNumber);
                  return [...prevObjs, response?.data?.data];
                });
              }
              setAppProperties((prevApp) => ({
                ...prevApp,
                savedNumbers: [
                  ...(prevApp?.savedNumbers?.filter((obj) => obj?.phoneNumber !== response?.data?.data?.phoneNumber) || []),
                  response?.data?.data,
                ],
                allNumbers: [
                  ...(prevApp?.allNumbers?.filter((obj) => obj?.phoneNumber !== response?.data?.data?.phoneNumber) || []),
                  response?.data?.data,
                ],
              }));
            } else if (response?.data?.license) {
              HNotification.notify({
                type: "error",
                message: response?.data?.license?.code,
                description: response?.data?.license?.description,
              });
            } else {
              HNotification.notify({ type: "error", message: "Error", description: "Something went wrong. Please try again." });
            }
            setShowEditContent(false);
            setAddBtnLoading(false);
          }
        } catch (error) {
          console.error("Error processing response:", error);
        }
      })
      .catch((err) => {
        setAddBtnLoading(false);
      });
  };

  const verifyMessagingService = (value) => {
    fetchData(`${integId}/verifyNumber?number=` + value, "GET", null, appProperties).then((response) => {
      if (response) {
        let savePhoneResp = JSON.parse(response);
        if (savePhoneResp?.data?.status === false) {
          const errorMessage = "No numbers connected !";
          const errorDescription = (
            <span>
              To use this messaging service, please add one or more numbers to it, in the Twilio console and return here.{" "}
              <Link
                href="https://help.twilio.com/articles/4402705042075-Managing-a-Messaging-Service-Sender-Pool#h_01H266YMP2NG092378YJ3PR315"
                target="_blank"
              >
                Read more
              </Link>
            </span>
          );
          HNotification.notify({ type: "error", message: errorMessage, description: errorDescription });
          setAddBtnDisabled(true);
        } else {
          setAddBtnDisabled(false);
          setSelectedPhone({
            ...selectedPhone,
            phoneNumber: value,
          });
        }
      }
    });
  };

  const handleAlphaSenderSelect = (value) => {
    let alphaSender = alphaDataOptions.find((alphaSender) => alphaSender.value === value);
    setSelectedPhone({
      ...selectedPhone,
      phoneNumber: alphaSender?.data?.alphaSender,
      messageServiceId: alphaSender?.data?.serviceSid,
    });
  };

  return (
    <Space direction="vertical" size="middle" className="w-100 p-4">
      <div className="d-flex flex-column gap-4">
        {selectedMenuItem !== "Phone number" ? (
          <div className="edit-head">{selectedMenuItem === "AlphaSender" ? "Choose Alpha Sender ID" : "Choose Messaging service"}</div>
        ) : (
          <div className="edit-head-phone">Number Configuration</div>
        )}
        {selectedMenuItem !== "MessagingService" ? (
          <div className="editPhoneLabel">
            <HSelect
              label={selectedMenuItem === "Phone number" ? "Phone Number" : "Alpha Sender ID"}
              options={alphaDataOptions}
              disabled={selectedMenuItem === "Phone number" ? true : false}
              loading={alphaDataLoading}
              placeholder="Enter Alpha Sender ID"
              customProps={{
                searchboxplaceholder: "Search Alpha Sender ID",
                variant: "borderless",
                value: selectedPhone?.phoneNumber,
                onSelect: handleAlphaSenderSelect,
              }}
            />
          </div>
        ) : null}
        {selectedMenuItem !== "AlphaSender" && appProperties.rightServiceName === "twilio" ? (
          <div className="editPhoneLabel">
            <HSelect
              label="Messaging Service"
              placeholder="Choose Messaging service"
              customProps={{
                value: associatedSid || selectedPhone?.messageServiceId,
                onSelect: (e) => {
                  if (selectedMenuItem !== "MessagingService") {
                    setAssociatedSid(e);
                  } else {
                    verifyMessagingService(e);
                  }
                },
              }}
              suffixIcon={<div className="actionIconsSprite fromNumberDropDownIcon" />}
              options={msgSidList?.map((number) => {
                return {
                  label: number.friendlyName + "(" + number.sid + ")",
                  value: number.sid,
                };
              })}
            />
          </div>
        ) : null}
        <div className="editPhoneLabel">
          <Input
            formItemLabel="Friendly Name"
            value={selectedPhone?.friendlyName}
            variant="borderless"
            className="editPhoneInputs"
            style={{ borderRadius: 8 }}
            placeholder="Enter friendly name"
            onChange={(e) => {
              setSelectedPhone({
                ...selectedPhone,
                friendlyName: e.target.value,
              });
            }}
            maxLength={MAX_INPUT_LENGTH_FOR_FRIENDLY_NAME}
          />
        </div>
        {departmentsList?.length > 0 && (
          <>
            <div className="editPhoneLabel">
              <>
                <HSelect
                  label="Department"
                  placeholder="Choose Department"
                  customProps={{
                    value: selectedDepartmentId ?? selectedPhone?.departmentId,
                    onSelect: (departmentId) => {
                      handlePhoneNumberDepartmentAssociation(departmentId);
                    },
                  }}
                  size="s"
                  className="w-50"
                  value={selectedPhone?.departmentId}
                  options={departmentsList?.map((department) => {
                    return {
                      label: department.name,
                      value: department.id,
                    };
                  })}
                />
              </>
            </div>
            <div className="editPhoneLabel">
              <>
                Assign tickets to
                <HSelect
                  placeholder="Choose Agent"
                  customProps={{
                    value: selectedAgentId ?? selectedPhone?.ticketAssigneeId,
                    onSelect: (agentId) => {
                      handlePhoneNumberTicketAssignee(agentId);
                    },
                  }}
                  size="s"
                  className="w-50"
                  options={agentsList}
                  value={selectedPhone?.ticketAssigneeId}
                />
              </>
            </div>
          </>
        )}
        <div className="d-flex gap-2 justify-content-end align-items-center mt-3 w-100">
          <HButton
            variant="cancel"
            size="s"
            onClick={() => {
              setShowEditContent(false);
              setSelectedPhone({});
              setAddBtnDisabled(false);
            }}
          >
            Cancel
          </HButton>
          <HButton
            size="s"
            buttonClassName="w-25"
            type="primary"
            disabled={addBtnDisabled}
            onClick={() => {
              selectedMenuItem === "Phone number" ? handlePhoneUpdate() : handlePhoneNumberApi("Table", true);
            }}
            loading={addBtnLoading}
          >
            Save
          </HButton>
        </div>
        {selectedMenuItem === "AlphaSender" && <AlphaSenderInfo showFullWidth={true} />}
      </div>
    </Space>
  );
};

function AlphaSenderInfo({ showFullWidth }) {
  return (
    <div className="mt-5 w-100 d-flex justify-content-center">
      <div className={`${showFullWidth ? "w-100" : "hs-w-90"}`}>
        <MessageAreaInfo
          icon={true}
          animated={false}
          messageColorClassName="hs-color-violet"
          message={
            <span>
              Alphanumeric Sender ID is not supported in the US or Canada,{" "}
              <a
                className="text-decoration-underline"
                href="https://help.twilio.com/articles/223133767-International-support-for-Alphanumeric-Sender-ID"
                target="_blank"
              >
                View supported countries
              </a>
              . &nbsp;Only SMS Messages sent via Alpha Sender are one-way — recipients cannot reply.
            </span>
          }
          type="info"
          key="alpha-sender-info"
        />
      </div>
    </div>
  );
}
